module.exports = __webpack_public_path__ + "img/product-showcase.69c54c99.webp";